'use client'
import { Icon } from '@/components'
import { IconButton } from '@mui/material'

export const MembershipHeader = () => {
  return (
    <IconButton
      sx={(theme) => ({
        background: '#222',
        color: theme.palette.common.white,
        padding: '10px',
        '&:hover': { background: theme.palette.primary.main },
      })}
    >
      {' '}
      <Icon.Crown />
    </IconButton>
  )
}
